import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { InputFormField } from '@playbookux/playbook-web-core';

import {
  PreferenceUploadRowContainer,
  PreferenceUploadRowOptionsCol,
  PreferenceUploadRowTextCol,
} from '../styles';
import RemoveButton from '../remove-button';
import { MAX_FILE_SIZE, SUPPORTED_FORMATS } from '../../survey-const';
import UploadButton from '../../../../../core/components/upload-file-button';

const PreferenceUploadRow = ({
  label,
  handleRemove,
  disabled,
  isEdit,
  uploadConfig: {
    index,
    setUploadError,
    handleChangeImage,
    imageUrl,
    imageKey,
  },
}) => (
  <PreferenceUploadRowContainer>
    <PreferenceUploadRowTextCol>
      <Field
        name={label}
        placeholder="Image Name"
        component={InputFormField}
        audience
        widthsize="100%"
      />
    </PreferenceUploadRowTextCol>
    <PreferenceUploadRowOptionsCol>
      <UploadButton
        text="Upload"
        index={index}
        onSetUploadError={setUploadError}
        endpointUrl="/presigned_url_upload_image"
        onChangeMedia={handleChangeImage}
        mediaUrl={imageUrl}
        mediaKey={imageKey}
        maxFileSize={MAX_FILE_SIZE}
        supportedFormats={SUPPORTED_FORMATS}
        maxHeight="32px"
      />
      <RemoveButton
        onClick={handleRemove}
        disabled={disabled}
        isEdit={isEdit}
      />
    </PreferenceUploadRowOptionsCol>
  </PreferenceUploadRowContainer>
);

PreferenceUploadRow.propTypes = {
  label: PropTypes.string.isRequired,
  handleRemove: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isEdit: PropTypes.bool,
  uploadConfig: PropTypes.shape({
    index: PropTypes.number.isRequired,
    setUploadError: PropTypes.func.isRequired,
    handleChangeImage: PropTypes.func.isRequired,
    imageUrl: PropTypes.string,
    imageKey: PropTypes.string,
  }).isRequired,
};

PreferenceUploadRow.defaultProps = {
  disabled: false,
  isEdit: false,
};
export default PreferenceUploadRow;
